export const getFilename = (path: string): string => {
  return path.replace(/^(.*\/)?([^/]+)$/, '$2');
};
